<template>
  <div>
    <h2>Ingresa el código de verificación</h2>
    <input v-model="code" type="text" placeholder="Código OTP" />
    <button @click="verifyOTP">Verificar</button>
    
    <div v-if="timeRemaining > 0" class="timer">
      Tiempo restante: {{ formatTime(timeRemaining) }}
    </div>
    <div v-else class="timer expired">
      Código expirado. Solicita un nuevo código.
    </div>
    
    <p v-if="error">{{ error }}</p>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import axios from "axios";
import { useStore } from "vuex";

const store = useStore();
let session = computed(() => store.getters.getUserSession);

const code = ref("");
const error = ref("");
const timeRemaining = ref(300); // 5 minutos en segundos
let timerInterval = null;

// Función para formatear el tiempo en MM:SS
const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

// Iniciar el temporizador cuando se monta el componente
onMounted(() => {
  startTimer();
});

// Limpiar el temporizador cuando se desmonta el componente
onUnmounted(() => {
  clearInterval(timerInterval);
});

// Iniciar la cuenta regresiva
const startTimer = () => {
  timerInterval = setInterval(() => {
    if (timeRemaining.value > 0) {
      timeRemaining.value--;
    } else {
      clearInterval(timerInterval);
    }
  }, 1000);
};

const verifyOTP = async () => {
  // Si el tiempo expiró, mostrar error y no verificar
  if (timeRemaining.value <= 0) {
    error.value = "El código ha expirado. Por favor, solicita un nuevo código.";
    return;
  }

  const token = session.value ? session.value.token_api : null;
  const userId = 3; // Establecer user_id por defecto en 3

  if (!token) {
    error.value = "No se encontró el token de autenticación. Vuelve a iniciar sesión.";
    return;
  }

  try {
    const url = `${process.env.VUE_APP_API_BASE_URL}/verify-otp`;

    const options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    // Enviar user_id con el valor fijo de 3
    const response = await axios.post(url, { user_id: userId, code: code.value }, options);

    if (response.status === 200) {
      alert("Código verificado");
    }
  } catch (err) {
    error.value = err.response?.data?.message || "Código incorrecto o expirado";
  }
};
</script>

<style scoped>
.timer {
  margin-top: 15px;
  font-size: 1.2rem;
  font-weight: bold;
}

.expired {
  color: red;
}
</style>
  